import React, { Fragment } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { connect } from 'react-redux';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js';
import { Button, Container } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// components

import config from '../config';
// const stripePromise = loadStripe(config.stripePublicKey);
import ReactDOM from 'react-dom';
import { setAlert } from '../actions/alert';
import { setToLoading, setToLoaded } from '../actions/loader';
import { sickNoteService } from '../services/sicknote.service';
import { getFeeConfig } from '../services/config.service';
import { history } from '../_helpers';

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      //     iconColor: "#c4f0ff",
      //     color: "#fff",
      //     fontWeight: 500,
      //     fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: '16px'
      //     fontSmoothing: "antialiased",
      //     ":-webkit-autofill": {
      //       color: "#fce883"
      //     },
      //     "::placeholder": {
      //       color: "#87bbfd"
      //     }
      //   },
      //   invalid: {
      //     iconColor: "#ffc7ee",
      //     color: "#ffc7ee"
    }
  }
};

const mapDispatchToProps = {
  setAlert,
  setToLoaded,
  setToLoading
};
const mapStateToProps = state => ({
  sickNote: state.sickNote,
  user: state.auth.user
});
class CheckoutForm extends React.Component {
  constructor() {
    super();
    this.state = {
      isDialog: false
    };
  }
  handleServerResponse = async response => {
    if (response.data.success) {
      this.props.setToLoaded();

      const { sickNote } = this.props;
      const formType = sickNote.data?.formType || 'sick-note';
      const formId = sickNote.data?.formId || response.data.extras?.formId;
      const accessToken = sickNote.data?.accessToken || response.data.extras?.accessToken;

      // Store form ID in localStorage for recovery after payment
      if (formType === 'school-work-form' && formId) {
        localStorage.setItem('schoolWorkFormId', formId);
      }

      // For school-work forms, redirect to the file upload page instead of showing dialog
      if (formType === 'school-work-form' && formId) {
        // If we have an accessToken, use the token-based URL
        if (accessToken) {
          history.push(`/school-work-form/upload-token/${encodeURIComponent(accessToken)}`);
        } else {
          // Fallback to ID-based URL
          history.push(`/school-work-form/upload/${formId}`);
        }
        return;
      }

      // Original sick note flow - show success dialog
      this.props.setAlert('Payment success.', 'success');
      this.setState({
        isDialog: true
      });
      return;
    }

    if (response.data.requires_action) {
      console.log('🔍 3DS Debug - Full response structure:', response.data);
      console.log('🔍 3DS Debug - next_action:', response.data.next_action);

      // NEW: Handle redirect-based 3DS for 2025-07-30.basil API
      if (response.data.next_action && response.data.next_action.type === 'redirect_to_url') {
        // Redirect to 3DS authentication page
        console.log('🔄 Redirecting to 3DS authentication page:', response.data.next_action.redirect_to_url.url);
        window.location.href = response.data.next_action.redirect_to_url.url;
        return;
      } else {
        // FALLBACK: Use old iframe method for backwards compatibility
        let intentConfirm = await this.props.stripe.handleCardAction(response.data.payment_intent_client_secret);
        if (!intentConfirm || !intentConfirm.paymentIntent) {
          this.props.setAlert('Card validation error.', 'danger');
          return;
        }
        try {
          response = await sickNoteService.charge({
            payment_intent_id: intentConfirm.paymentIntent.id,
            sickNote: this.props.sickNote
          });

          return await this.handleServerResponse(response);
        } catch (error) {
          this.props.setToLoaded();
          this.props.setAlert(error.message || 'Payment processing error', 'danger', 5000, 'alert-fixed');
        }
      }
    }
    this.props.setToLoaded();
    console.log(response);
    return this.props.setAlert(response.data.error || 'Card failed.', 'danger', 5000, 'alert-fixed');
  };
  handleSubmit = async event => {
    event.preventDefault();

    const { stripe, elements } = this.props;
    const { sickNote } = this.props;

    // Make sure we're sending the proper data structure to the server
    const paymentData = {
      ...sickNote.data,
      formId: sickNote.data?.formId, // Ensure formId is included
      formType: sickNote.data?.formType || 'sick-note'
    };

    if (elements == null) {
      return;
    }

    this.props.setToLoading();

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement)
      });

      if (error) {
        this.props.setToLoaded();
        return this.props.setAlert(error.message, 'danger', 5000, 'alert-fixed');
      }

      let response = await sickNoteService.charge({
        payment_method_id: paymentMethod.id,
        sickNote: paymentData // Send the properly structured data
      });

      await this.handleServerResponse(response);
    } catch (error) {
      this.props.setToLoaded();
      this.props.setAlert(error.message || 'Payment processing error', 'danger', 5000, 'alert-fixed');
    }
  };

  handleDialogClose = () => {
    this.setState({ isDialog: false });
    history.push('/dashboard');
  };

  handleGoBack = () => {
    const { sickNote } = this.props;
    const formType = sickNote.data?.formType || 'sick-note';

    // Navigate back based on form type
    const backPath = formType === 'school-work-form' ? '/school-work-form' : '/sick-note';

    history.push(backPath);
  };

  render() {
    const { stripe, user, sickNote } = this.props;
    const formType = sickNote.data?.formType || 'sick-note';

    return (
      <Fragment>
        <Dialog open={this.state.isDialog}>
          <DialogTitle>{formType === 'school-work-form' ? 'Request a Form' : 'Sick Note'} request submitted successfully</DialogTitle>
          <DialogContent>Doctor Budai will get back to you within 24 hours through email. The email we have on file is {user.email}.</DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose}>OK</Button>
          </DialogActions>
        </Dialog>
        <div className="checkout-form mt-2">
          <form onSubmit={this.handleSubmit}>
            <div className="checkout-form__card">
              <CardElement />
            </div>
            <div className="checkout-form__buttons mt-1">
              <button className="checkout-form__buttons__button btn btn-primary full-width ml-0" type="submit" disabled={!stripe}>
                Pay now
              </button>
              <button className="mt-1 checkout-form__buttons__button btn btn-secondary full-width ml-0" type="button" onClick={this.handleGoBack}>
                Go back
              </button>
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}
let CheckoutFormConnect = connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);

const InjectedCheckoutForm = () => <ElementsConsumer>{({ stripe, elements }) => <CheckoutFormConnect stripe={stripe} elements={elements} />}</ElementsConsumer>;

const stripePromise = loadStripe(config.stripePublicKey);

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feeConfig: null,
      isLoading: true
    };
  }

  async componentDidMount() {
    try {
      const feeConfig = await getFeeConfig();
      this.setState({ feeConfig, isLoading: false });
    } catch (error) {
      console.error('Failed to load fee config:', error);
      this.setState({ isLoading: false });
    }
  }

  calculateAmount = () => {
    const { sickNote } = this.props;
    const { feeConfig } = this.state;

    if (!feeConfig) return 'Loading...';

    // Access data properly based on Redux structure
    const sickNoteData = sickNote.data || sickNote;

    // Get form type from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get('formType') || 'sick-note';

    // Handle school-work-form pricing
    if (formType === 'school-work-form') {
      // Use calculated price if available, otherwise calculate from config
      if (sickNoteData.calculatedPrice) {
        return sickNoteData.calculatedPrice;
      }

      if (sickNoteData.timeOffIsFor === 'disability') {
        return feeConfig.SCHOOL_WORK_FORM.DISABILITY_FLAT_FEE;
      } else {
        // Calculate based on pages: first page + additional pages
        const pageCount = sickNoteData.pageCount || 1;
        const additionalPages = Math.max(0, pageCount - 1);
        return feeConfig.SCHOOL_WORK_FORM.FIRST_PAGE + additionalPages * feeConfig.SCHOOL_WORK_FORM.ADDITIONAL_PAGE;
      }
    }

    // Use sick-note pricing for regular sick notes
    if (sickNoteData.isPrivate) {
      return feeConfig.SICK_NOTE.PRIVATE;
    } else {
      return feeConfig.SICK_NOTE.MSP_ELIGIBLE;
    }
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="payment">
          <Container>
            <h1 className="keywords">Loading fee information...</h1>
          </Container>
        </div>
      );
    }

    const amount = this.calculateAmount();

    // Get form type for display
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get('formType') || 'sick-note';
    const formDisplayName = formType === 'school-work-form' ? 'request a form' : 'sick note';

    return (
      <div className="payment">
        <Container>
          <h1 className="keywords">Fee</h1>
          <p className="mb-2">Please pay the following fee in order to obtain your {formDisplayName}:</p>
          <span className="payment__fee badge badge-pill badge-warning">Fee: ${amount}</span>
          <Elements stripe={stripePromise}>
            <InjectedCheckoutForm />
          </Elements>
        </Container>
      </div>
    );
  }
}
let temp = connect(mapStateToProps, mapDispatchToProps)(Payment);
export { temp as Payment };
